import React from "react";

import { TTSControlReducer } from './TTSControlReducer.js';

class Poll extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasTTSSupport: false,
      playState: 'IDLE',
      selectedVoiceIndex: 0,
      rate: 1,
      pitch: 1,
    };
  }

  componentDidMount() {
    this.detectTTSSupport(window.location.hash == '#tts');
  }

  detectTTSSupport(autoplay) {
    if ('speechSynthesis' in window) {
      const voices = window.speechSynthesis.getVoices();

      if (voices.length === 0) {
        window.speechSynthesis.onvoiceschanged = () => {
          const voices = window.speechSynthesis.getVoices();

          this.enableTTSSupport(voices, autoplay);
        };
      } else {
        this.enableTTSSupport(voices, autoplay);
      }
    }
  }

  enableTTSSupport(voices, autoplay) {
    const voiceIndex = this.getBestvoice(voices);

    this.setState(TTSControlReducer(this.state, {
      type: 'TTS_SUPPORT_FOUND',
      voices,
      voiceIndex,
    }), () => {
      if (autoplay) {
        this.handlePlay();
      }
    });
  }

  getBestvoice(voices) {
    const possibleLatamSpanish = voices
      .map((voice, index) => [voice, index])
      .filter(([voice, _]) => voice.lang.startsWith('es-419'))
      .map(([_, index]) => index);

    const possibleSpanish = voices
      .map((voice, index) => [voice, index])
      .filter(([voice, _]) => voice.lang.startsWith('es'))
      .map(([_, index]) => index);

    const possibleDefault = voices
      .map((voice, index) => [voice, index])
      .filter(([voice, _]) => voice.default)
      .map(([_, index]) => index);

    if (possibleLatamSpanish.length > 0) {
      return possibleLatamSpanish[0];
    }

    if (possibleSpanish.length > 0) {
      return possibleSpanish[0];
    }

    if (possibleDefault.length > 0) {
      return possibleDefault[0];
    }

    return 0;
  }

  handlePlay() {
    const utterance = new SpeechSynthesisUtterance();

    utterance.rate = this.state.rate;
    utterance.pitch = this.state.pitch;
    utterance.voice = this.state.voices[this.state.selectedVoiceIndex];
    utterance.text = document.getElementById('article-title-tts').textContent + '. ' + document.getElementById('article-content-tts').textContent;

    utterance.onend = () => { this.handleFinished() };
    utterance.onerror = () => { this.handleFinished() };

    window.speechSynthesis.speak(utterance);

    this.setState(TTSControlReducer(this.state, {
      type: 'PLAY',
    }));
  }

  handleFinished() {
    this.setState(TTSControlReducer(this.state, {
      type: 'FINISHED',
    }));
  }

  handleResume() {
    window.speechSynthesis.resume();

    this.setState(TTSControlReducer(this.state, {
      type: 'RESUME',
    }));
  }

  handlePause() {
    window.speechSynthesis.pause();

    this.setState(TTSControlReducer(this.state, {
      type: 'PAUSE',
    }));
  }

  handleStop() {
    window.speechSynthesis.cancel();

    this.setState(TTSControlReducer(this.state, {
      type: 'STOP',
    }));
  }

  handleVoiceSelectChange(event) {
    this.setState(TTSControlReducer(this.state, {
      type: 'VOICE_SELECTED',
      voiceIndex: event.target.value,
    }));
  }

  render() {
    if (!this.state.hasTTSSupport) {
      return (<></>);
    }

    const playButton = <button onClick={() => { this.handlePlay() }}><i className="fas fa-volume-up"></i> Escuchar el artículo</button>;
    const pauseButton = <button onClick={() => { this.handlePause() }}><i className="fas fa-pause"></i></button>;
    const resumeButton = <button onClick={() => { this.handleResume() }}><i className="fas fa-play"></i></button>;
    const stopButton = <button onClick={() => { this.handleStop() }}><i className="fas fa-stop"></i></button>;

    let buttonSet;

    switch (this.state.playState) {
      case 'PAUSED':
        buttonSet = <>
          {resumeButton}{stopButton}
        </>;
        break;
      case 'PLAYING':
        buttonSet = <>
          {pauseButton}{stopButton}
        </>;
        break;
      case 'IDLE':
      default:
        buttonSet = playButton;
    }

    return (
      <div className="tts-control">
        <select value={this.state.selectedVoiceIndex} onChange={(event) => { this.handleVoiceSelectChange(event) }} disabled={this.state.playState!=='IDLE'}>
          {this.state.voices.map((voice, index) => {
            return (<option key={index} value={index}>{voice.name}</option>);
          })}
        </select>
        <div className="controls">
          {buttonSet}
        </div>
      </div>
    );
  }
}

export default Poll;
